import isUndefined from 'lodash/isUndefined';

const formatItemData = (cartItem) => {
  if (!cartItem) {
    return;
  }
  const formattedItemData = {
    item_id: cartItem.sku,
    item_name: cartItem.name,
    price: parseFloat(cartItem.price),
    quantity: cartItem.qty || 1,
  };
  return formattedItemData;
};

export const trackEvent = (eventName, payload) => {
  if (gtag && !isUndefined(gtag)) {
    gtag('event', eventName, payload);
  }
};

export const formatItemDataEvent = (product) => {
  if (!product) {
    return;
  }
  const formattedItemData = formatItemData(product);
  const formattedItemEventData = {
    currency: 'USD',
    value: parseFloat(product.salePrice),
    items: [formattedItemData],
  };
  return formattedItemEventData;
};

export const formatBeginCheckoutDataEvent = (cartData) => {
  if (!cartData) {
    return;
  }
  const formattedCartItems = cartData.cartItemIds.map((sku) => {
    const currentItem = cartData.cartProducts[sku];
    return formatItemData(currentItem);
  });
  const formattedBeginCheckoutEventData = {
    currency: 'USD',
    value: parseFloat(cartData.totals.totals.orderTotalWithTax),
    coupon: cartData.promoCode,
    coupons: cartData.couponCodes,
    items: [formattedCartItems],
  };
  return formattedBeginCheckoutEventData;
};

export const formatPurchaseData = (orderNumber, cartData) => {
  if (!orderNumber || !cartData) {
    return;
  }
  const formattedCartItems = cartData.cartItemIds.map((sku) => {
    const currentItem = cartData.cartProducts[sku];
    return formatItemData(currentItem);
  });
  const formattedPurchaseData = {
    transaction_id: orderNumber,
    value: parseFloat(cartData.totals.totals.orderTotalWithTax),
    tax: parseFloat(cartData.totals.totals.orderTotalTax),
    shipping: parseFloat(cartData.totals.totals.shippingTotal),
    coupon: cartData.promoCode,
    coupons: cartData.couponCodes,
    currency: 'USD',
    items: formattedCartItems,
  };
  return formattedPurchaseData;
};
